import classes from "./Services.module.css";
import { useInView } from "react-intersection-observer";

const Services = () => {
  const { ref, inView } = useInView({
    rootMargin: "0px 0px 30% 0px",
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div className="services">
      <div className={classes.services}>
        <h1>Services</h1>
        <div className={classes["services-box"]}>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
            ref={ref}
          >
            <i class="fas fa-globe fa-6x" aria-hidden="true"></i>
            <h2>Web Developing</h2>
            <p>
              I can make beautiful website as per requirement by using modern
              web technologies.
            </p>
          </div>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
          >
            <i class="fas fa-mobile fa-6x" aria-hidden="true"></i>
            <h2>Front-End Web Application Development</h2>
            <p>
              I can make beautiful Front-end web application as per requirement
              by using modern web technologies like modern javascript js & react
              js.
            </p>
          </div>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
          >
            <i class="fas fa-network-wired fa-6x" aria-hidden="true"></i>
            <h2>Back-end Web Application Developing</h2>
            <p>
              I can create super fast & modern backend technologies by using
              node js, express js & mongodb.
            </p>
          </div>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
          >
            <i class="fas fa-code fa-6x"></i>
            <h2>Programming</h2>
            <p>
              I can Programm as per requirement for specific task. I have great
              knowlege of writing programmes in modern Javascript, Java, Python
              & C++.
            </p>
          </div>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
          >
            <i class="fas fa-wrench fa-6x"></i>
            <h2>Web Application Maintain</h2>
            <p>
              I can maintain Web Application by changing the code with modern
              syntax for specific technology.
            </p>
          </div>
          <div
            className={`${classes["service-box-item"]} ${
              inView ? classes["service-box-item-active"] : ""
            }`}
          >
            <i class="fas fa-desktop fa-6x"></i>
            <h2>Web UI/UX</h2>
            <p>I can create beautiful UI/UX in Web application Development.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
